import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useState,
} from "react";
import { Container } from "react-grid-system";
import { Outlet } from "react-router-dom";

import { PublicHeader } from "components/public-header";
import { PageFooter } from "components/shared/page-footer";

import styles from "./shingle-repair-pilot.module.scss";

export type ShingleContextState = {
  policyId: string;
  firstName: string;
  lastName: string;
  propertyAddress: {
    street1?: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
  } | null;
  email: string;
  phoneNumber: string;
  phoneNumberFormatted: string;
  insightPolicyId: string | null;
} | null;

export const ShingleContext = createContext<{
  state: ShingleContextState;
  setState: Dispatch<SetStateAction<ShingleContextState>>;
}>({ state: null, setState: () => null });

const ShingleRepairPilot = () => {
  const [state, setState] = useState<ShingleContextState>(null);

  return (
    <ShingleContext.Provider value={{ state, setState }}>
      <PublicHeader hideNav />
      <Container className={styles.content}>
        <Outlet />
      </Container>
      <PageFooter unauthenticated />
    </ShingleContext.Provider>
  );
};

export default ShingleRepairPilot;
